/* eslint-disable react/no-unescaped-entities */

const AboutUsEN = () => {
  return (
    <>
      <h1>About Us</h1>
      <h2>Our Mission</h2>
      <div>
        At mind-r.ai, we've embarked on a journey to democratize access to
        mental health care. We believe in the power of technology as a tool to
        break down barriers, erase boundaries, and make therapy universally
        accessible. We've seen the debilitating effects untreated mental health
        conditions can have on individuals and societies - escalating
        incarceration rates, economic costs reaching up to 4% of global GDP, and
        more. Our mission is to change that narrative.
      </div>
      <div>
        We envision a world where everyone, regardless of their location,
        language, or economic status, can access the therapeutic support they
        need. We want to normalize seeking help, reduce stigma, and create a
        future where prioritizing mental health is the norm, not the exception.
        Our goal isn't just about providing a service. It's about initiating a
        movement towards better mental health for all.
      </div>

      <h2>The Global Impact of Mental Health</h2>
      <div>
        Mental health issues profoundly burden our world. They rank among the
        leading causes of ill-health and disability worldwide, affecting one in
        four people at some point in their lives
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        . Experts estimate that untreated mental health issues account for 13%
        of the total global burden of disease
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        .
      </div>

      <div>
        Mental health issues profoundly burden our world. They rank among the
        leading causes of ill health and disability worldwide, affecting one in
        four people at some point in their lives
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        . Experts estimate that untreated mental health issues account for 13%
        of the global disease burden
        <a
          href="https://www.who.int/news-room/fact-sheets/detail/mental-disorders"
          target="_blank"
        >
          [1]
        </a>
        .
      </div>

      <div>
        The economic implications are striking. The global economy could lose
        $16 trillion by 2030 due to mental health issues due to decreased
        productivity and increased healthcare costs
        <a
          href="https://www.thelancet.com/commissions/global-mental-health"
          target="_blank"
        >
          [2]
        </a>
        . Individuals with untreated mental health issues often face a reduced
        quality of life, a higher risk of physical health problems, and
        increased unemployment rates.
      </div>

      <div>
        Beyond economic factors, mental health issues can lead to higher levels
        of violence and crime. Up to 90% of prisoners have experienced mental
        health issues
        <a href="https://www.ncbi.nlm.nih.gov/books/NBK533137/" target="_blank">
          [3]
        </a>
        . These issues also contribute to societal problems like homelessness
        and broken families.
      </div>

      <div>
        At mind-r.ai, we are well aware of the broad impacts of mental health
        issues and are committed to being part of the solution. By democratizing
        therapy access, we aim to alleviate the mental health burden one
        individual at a time. Our mission goes beyond healthcare; we strive to
        create a better, more understanding world.
      </div>

      <h2>Our Approach</h2>
      <div>
        We mark our path to democratizing therapy with innovation and
        accessibility. Artificial intelligence powers our strategy, and we
        harness it to understand and cater to every individual's needs and
        circumstances. We build complex algorithms to match user preferences,
        creating unique and personalized experiences.
      </div>
      <div>
        We hold strong beliefs in the principle of empathy-driven technology. We
        design each feature with the user's needs and experiences to integrate
        therapy into everyday life. Our approach centres on inclusivity,
        tailoring our solutions for everyone, regardless of language, location,
        or socioeconomic status.
      </div>
      <div>
        As we take every step, our mission to make mental health care
        universally accessible guides us. Our commitment to this goal shapes our
        approach, influences our decisions, and propels us towards our vision.
      </div>
      <h2>Our Service</h2>
      <div>
        At mind-r.ai, we've transformed the traditional therapy concept by
        providing an AI-driven, voice-based platform. Meet Solace, our AI
        therapist, ready to lend an ear anytime, anywhere. Solace breaks down
        barriers of time, language, and geography, offering therapy type,
        duration, theme, language, and even accent according to user
        preferences. Our unique offering opens a world of mental health
        resources to anyone, anytime, anywhere.
      </div>
      <div>
        As an adaptable companion, Solace tailors its approach to each
        individual's needs. From providing deep, introspective conversations to
        offering casual, comforting chats, Solace matches our users' moods and
        needs. Therapy should be as diverse and dynamic as the individuals
        seeking it.
      </div>
      <div>
        After each therapy session with Solace, we generate a summary and
        practical actions. These are not just report cards; they're tools to
        empower individuals in their ongoing mental health journey, providing
        the insights and steps needed to continue making progress. We're proud
        to be redefining therapy, making it more accessible, personalized, and
        user-focused than ever before. Our service is more than a product; it
        reflects our commitment to democratizing mental health care.
      </div>

      <h2>Our Values</h2>

      <ul>
        <li>
          <strong>Empathy</strong>: At the heart of our work lies a profound
          sense of empathy. We strive to understand the unique experiences and
          challenges faced by each individual using our platform, and to provide
          support and solutions that meet their specific needs.
        </li>
        <li>
          <strong>Innovation</strong>: We believe in the power of technology to
          create new ways to support mental health. We continually seek to
          improve and expand our platform's capabilities through innovative
          approaches.
        </li>
        <li>
          <strong>Accessibility</strong>: Our ultimate goal is to make mental
          health support accessible to all. We aim to eliminate barriers to
          therapy, such as cost, stigma, and logistics, and to create a platform
          that can be used by anyone, anywhere.
        </li>
        <li>
          <strong>Respect</strong>: We respect the privacy and autonomy of our
          users. All interactions on our platform are confidential and
          user-centric. We believe in empowering individuals to manage their
          mental health in ways that best suit them.
        </li>
        <li>
          <strong>Commitment</strong>: We are deeply committed to our mission of
          democratizing therapy. This commitment guides all of our actions and
          decisions as we continually strive to improve and expand our services.
        </li>
      </ul>

      <h2>Join Us</h2>
      <div>
        Are you ready to take the first step towards better mental health? Join
        the mind-r.ai community today and explore a new approach to therapy.
        Meet Solace, your AI therapist, ready to listen, understand, and guide
        you through your journey.
      </div>
    </>
  )
}

export default AboutUsEN
